module.exports = __webpack_public_path__ + "static/media/dna.e9586bb8.svg";